<template>
	<article class="hotel-general-description">
		<h2
			class="hotel-general-description__heading"
			v-text="title"
		></h2>
		<HotelDescriptionGrid
			class="hotel-general-description__items"
			:descriptions="hotelDescription"
			column-direction
		/>

		<BaseModal
			class="hotel-general-description__modal"
			:header-title="modalTitle"
			with-open-button
			:open-button-props="{ label: seeMoreButtonLabel, class: 'hotel-general-description-modal-btn' }"
			@open="showHotelInfosModal"
		>
			<HotelDescriptionGrid :descriptions="hotelDescription" />
		</BaseModal>
	</article>
</template>
<script lang="ts" setup>
import HotelDescriptionGrid from '@lmt-rpb/HotelDescriptionGrid/HotelDescriptionGrid.vue';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import type { Description } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';

interface Props {
	hotelDescription: Description[];
	seeMoreButtonLabel?: string;
	title?: string;
	modalTitle?: string;
}

withDefaults(defineProps<Props>(), {
	title: 'Allgemeine Beschreibung',
	seeMoreButtonLabel: 'Komplette Beschreibung',
	modalTitle: 'Allgemeine Beschreibung',
});

const emit = defineEmits(['show-more-button-click']);

const showHotelInfosModal = () => {
	emit('show-more-button-click');
};
</script>
<style lang="scss">
.hotel-general-description {
	&__heading {
		padding: 0;
		margin: 0;
		text-align: left;
		color: $color-text;
		margin-bottom: 1.6rem;
		font-size: $font-medium-3;
		font-family: $font-family-special;
		line-height: 2.7rem;

		@media (min-width: $breakpoint-small) {
			font-size: $font-medium-2;
		}

		@media (min-width: $breakpoint-large) {
			font-size: $font-large-4;
		}
	}

	&-modal-btn {
		margin-top: 0.8rem;
	}

	&__items {
		max-height: 27.5rem;
		position: relative;
		overflow: hidden;

		.hotel-description-item__header-title,
		.hotel-description-item__text {
			font-family: $font-family !important;
			color: $color-text;
		}

		&::before {
			background: linear-gradient(180deg, rgb(255 255 255 / 0%) 0%, $color-white 100%);
			content: '';
			position: absolute;
			z-index: 2;
			bottom: 0;
			left: 0;
			height: 3.6rem;
			width: 100%;
		}
	}
}
</style>
